// Help links used to point at a placeholder article; they ask the agent instead,
// so the answer covers this partner's own wallets.
export const WALLET_OVERVIEW_PROMPT =
  'How do funding wallets work? Explain where the cash and credit allocations come from, when the value is deducted, and which funding programs draw from them.'

export const walletHelpPrompt = (walletName: string) =>
  `Help me understand my ${walletName} wallet: what do the total, consumed, available and extra required amounts mean, and what kind of changes show up in its history?`

export const walletShortfallPrompt = (walletName: string, shortfall: string) =>
  `My funding requests exceed my ${walletName} wallet balance by ${shortfall}. What are my options to resolve this shortfall, and what do you recommend I do first?`
